<script setup lang="ts">
/**
 * Positions the popover against something other than its trigger — wrap an element, or pass
 * `reference` (an element, or any object with `getBoundingClientRect`) for a popover that has no
 * trigger at all: a coach-mark beside a rail icon, a card over a grid cell.
 */
import type { PopoverAnchorProps } from "reka-ui"
import { PopoverAnchor, useForwardProps } from "reka-ui"

const props = defineProps<PopoverAnchorProps>()

const forwarded = useForwardProps(props)
</script>

<template>
  <PopoverAnchor v-bind="forwarded">
    <slot />
  </PopoverAnchor>
</template>
